import {
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  FormHelperText,
  IconButton,
  ListItem,
  ListItemText,
  makeStyles,
  TextareaAutosize,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useStyles } from "../../assets/jss/DriverNotePopup";
import { useParams } from "react-router-dom";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import {
  adminGetDriverNotes,
  adminUpdateNoteReadStatus,
  adminUpsertDriverNote,
} from "../../services/AdminUserService";
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import { getUserData, getUserRBAC } from "../../services/LocalStorageService";
import saveNoteIcon from "../../assets/images/saveNote.svg";
import closeNoteIcon from "../../assets/images/closeNote.svg";
import editNoteIcon from "../../assets/images/editNote.svg";
import deleteNoteIcon from "../../assets/images/deleteNote.svg";
import addNoteIcon from "../../assets/images/addNote.svg";
import shareEnableIcon from "../../assets/images/shareEnable.svg";
import shareDisableIcon from "../../assets/images/shareDisable.svg";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import {
  EntityAccess,
  RBAC_CODE,
  RecordStatus,
} from "../../config/app-globals.enum";
import DeleteNoteDialog from "../Dialogs/ConfirmAction/DeleteNoteDialog";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";

export default function DriverNotePopup(props: any) {
  const { t } = useTranslation();
  const params = useParams();
  const [loggedInUserData] = useState<any>(getUserData);
  const { anchor, open, onClose, driverId, isNoteAdded, setIsNoteAdded } = props;
  const [userRBAC] = React.useState(getUserRBAC(RBAC_CODE.UPSERT_NOTE, props));
  const classes = useStyles();
  const [addNoteClicked, setAddNoteClicked] = useState(false);
  const [editNoteClicked, setEditNoteClicked] = useState(false);
  const [deleteNoteDisabled, setDeleteNoteDisabled] = useState(false);
  const [isApi, setIsApi] = useState(null);
  const [isUpsertNoteApi, setIsUpsertNoteApi] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [noteData, setNoteData] = useState({ noteList: [] });
  const [isNoteShared, setIsNoteShared] = useState(false);
  const [shareWithDriver, setShareWithDriver] = useState(false);
  const [noteAlertMessage, setNoteAlertMessage] = React.useState("");
  const [isNoteAlertOpen, setIsNoteAlertOpen] = React.useState(false);
  const [noteAlertStatusValue, setNoteAlertStatusValue] =
    React.useState<any>("");
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [noteAlertType, setNoteAlertType] = useState("error");
  const [rowSelectedIndex, setRowSelectedIndex] = useState(0);
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);
  const [isFocus, setIsFocus] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const inputRef = useRef<any>(null);
  const [textFieldDisabled, setTextFieldDisabled] = useState(true);
  const [noteTempObj, setNoteTempObj] = useState({
    id: "",
    userId: driverId !== null && driverId !== undefined ? driverId : 0,
    note: "",
    shareWithDriver: shareWithDriver,
    recordStatus: 1, // 1. add/update     2. delete
    createdByUserId: "",
    lastUpdatedByUserId: "",
    readStatus: 0,
    createdOn: "",
    lastUpdatedOn: "",
    lastUpdatedByUserName: "",
    createdByUserName: "",
  });

  useLayoutEffect(() => {
    if (!textFieldDisabled) inputRef?.current?.focus();
  }, [textFieldDisabled]);

  const [noteFormValidation, setNoteFormValidation] = useState({
    note: {
      isRequired: true,
      isValid: true,
      validationMessage: "",
    },
  });

  async function getNoteData(operationType: string) {
    try {
      // let data: any;
      setIsApi(true);
      const data = await adminGetDriverNotes(driverId, params);
      setIsApi(false);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        setNoteData({ noteList: data.content });
        setAddNoteClicked(false);
        if (data.content.length > 0) {
          if (
            userRBAC &&
            userRBAC.isAccessible === EntityAccess.ALLOWED &&
            rowSelectedIndex >= 0 &&
            rowSelectedIndex < data.content.length &&
            operationType !== "ADD" &&
            operationType !== "DELETE"
          ) {
            showNoteDetails(data.content[0]);
            setNoteTempObj(data.content[0]);
            setRowSelectedIndex(0);
            setTextFieldDisabled(true);
            setEditNoteClicked(false);
            setDeleteNoteDisabled(false);
          } else if (operationType === "DELETE" || operationType === "ADD") {
            showNoteDetails(data.content[0]);
            setRowSelectedIndex(0);
            setTextFieldDisabled(true);
            setSaveBtnDisabled(true);
            setEditNoteClicked(false);
          } else {
            if (userRBAC && userRBAC.isAccessible === EntityAccess.ALLOWED)
              setRowSelectedIndex(0);
            else
              setRowSelectedIndex(-1);
          }
        } else {
          setNoteData({ noteList: [] });
          if (operationType === "DELETE") {
            props.setIsNoteAdded(false);
            setTextFieldDisabled(false);
          }
          handleAddNoteClick();
        }
      } else {
        setNoteData({ noteList: [] });
        setNoteTempObj({
          id: "",
          userId: 0,
          note: "",
          shareWithDriver: false,
          recordStatus: 1,
          readStatus: 0,
          createdByUserId: "",
          lastUpdatedByUserId: "",
          createdOn: "",
          lastUpdatedOn: "",
          lastUpdatedByUserName: "",
          createdByUserName: "",
        });
      }
      noteApiStatusCodeFunc(data.status, "GET_NOTE");
      if (isNoteAdded) {
        setIsNoteAdded(false);
        handleAddNoteClick();
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      if (driverId !== null && driverId !== undefined && open) {
        setIsApi(true);
        getNoteData("READ");
      }
    } catch (error) {
      console.log(error);
    }
  }, [props]);

  const noteApiStatusCodeFunc = (status, apiType) => {
    if (status.code === 0 || status.code === 200 || status.code === 201) {
      if (apiType === "GET_NOTE") {
        return;
      }
      let msg = "";
      if (apiType === "ADD_NOTE") {
        msg = t("DRIVER_NOTE_ADDED_SUCCESSFULLY");
      }
      if (apiType === "UPDATE_NOTE") {
        msg = t("DRIVER_NOTE_UPDATED_SUCCESSFULLY");
      }
      if (apiType === "DELETE_NOTE") {
        msg = t("DRIVER_NOTE_DELETED_SUCCESSFULLY");
      }
      setNoteAlertType("success");
      setNoteAlertMessage(msg);
    } else {
      if (
        noteData?.noteList &&
        noteData.noteList.length > 0 &&
        apiType !== "ADD_NOTE"
      ) {
        showNoteDetails(noteData.noteList[0]);
        setRowSelectedIndex(0);
      }
      setNoteAlertType("error");
      setNoteAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
    }
    setNoteAlertStatusValue(status.code);
    setIsNoteAlertOpen(true);
  };

  async function upsertDriverNoteDetails(noteObj?: any) {
    try {
      let request = noteTempObj;
      if (noteObj) {
        request = noteObj;
      }
      setIsApi(true);
      const data = await adminUpsertDriverNote(request);
      // return
      setIsApi(false);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201)
      ) {
        // noteApiStatusCodeFunc(data.status, "ADD_NOTE");
        setNoteTempObj({
          id: "",
          userId: 0,
          note: "",
          shareWithDriver: false,
          recordStatus: 1,
          createdByUserId: "",
          lastUpdatedByUserId: "",
          createdOn: "",
          readStatus: 0,
          lastUpdatedOn: "",
          lastUpdatedByUserName: "",
          createdByUserName: "",
        });
        setAddNoteClicked(false);
        setSaveBtnDisabled(true);
        setEditNoteClicked(false);
        setDeleteNoteDisabled(false);
        if (addNoteClicked) {
          setIsNoteAdded(true);
          getNoteData("ADD");
        } else if (noteObj) {
          getNoteData("DELETE");
        } else {
          getNoteData("READ");
        }
        // setIsNoteUpserted(true);
      }
      if (noteObj) {
        noteApiStatusCodeFunc(data.status, "DELETE_NOTE");
      } else {
        if (addNoteClicked) {
          noteApiStatusCodeFunc(data.status, "ADD_NOTE");
        } else {
          noteApiStatusCodeFunc(data.status, "UPDATE_NOTE");
        }
      }
      setIsUpsertNoteApi(false);
    } catch (error) {
      console.log(error);
    }
  }

  const handleClose = (action) => {
    setTextFieldDisabled(true);
    setAddNoteClicked(false);
    setEditNoteClicked(false);
    setRowSelectedIndex(0);
    setNoteTempObj({
      id: "",
      userId: 0,
      note: "",
      shareWithDriver: false,
      recordStatus: 1,
      createdByUserId: "",
      lastUpdatedByUserId: "",
      createdOn: "",
      readStatus: 0,
      lastUpdatedOn: "",
      lastUpdatedByUserName: "",
      createdByUserName: "",
    });
    onClose(false, true);
    setDeleteDialogOpen(false);
  };

  const verifyUserInput = (userForm) => {
    setIsFormSubmit(true);
    // setIsFormValid(true);
    setIsFocus(true);
    let formValid = true;
    if (userForm) {
      let _noteFormValidation = { ...noteFormValidation };
      for (const [key, value] of Object.entries(noteFormValidation)) {
        const _value = { ...value };
        const currentValue = userForm[key];
        if (_value && _value.isRequired) {
          if (!currentValue || !currentValue.length || currentValue === null) {
            _value.isValid = false;
            _value.validationMessage = t("THIS_FIELD_CAN_NOT_BE_EMPTY");
            // setIsFormValid(false);
            formValid = false;
          }
        } else {
          _value.isValid = true;
          _value.validationMessage = "";
        }
        _noteFormValidation[key] = { ..._value };
      }
      setNoteFormValidation({ ..._noteFormValidation });
    }
    return formValid;
  };

  const handleSaveClick = () => {
    try {
      const validForm = verifyUserInput(noteTempObj);
      if (validForm) {
        setSaveBtnDisabled(true);
        setIsUpsertNoteApi(true);
        upsertDriverNoteDetails();
      }
    } catch (error) {
      console.log("error while adding driver note : ", error);
    }
  };

  const handleEditClick = () => {
    try {
      const validForm = verifyUserInput(noteTempObj);
      if (validForm) {
        setEditNoteClicked(true);
        setSaveBtnDisabled(false);
        setTextFieldDisabled(!textFieldDisabled);
        setDeleteNoteDisabled(true);
      }
    } catch (error) {
      console.log("error while editing driver note : ", error);
    }
  };

  async function updateReadStatus(noteId: string) {
    try {
      const data = await adminUpdateNoteReadStatus(noteId);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201)
      ) {
        var index = noteData.noteList.findIndex((item) => item.id === noteId);
        let tempObj = noteData.noteList.find((item) => item.id === noteId);
        if (index !== -1) {
          let object = {
            id: tempObj.id,
            userId: tempObj.userId,
            note: tempObj.note,
            shareWithDriver: tempObj.shareWithDriver,
            recordStatus: tempObj.recordStatus,
            createdByUserId: tempObj.createdByUserId,
            lastUpdatedByUserId: tempObj.lastUpdatedByUserId,
            createdOn: tempObj.createdOn,
            readStatus: 1,
            lastUpdatedOn: tempObj.lastUpdatedOn,
            lastUpdatedByUserName: tempObj.lastUpdatedByUserName,
          };
          noteData.noteList[index] = object;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function showNoteDetails(item) {
    try {
      setSaveBtnDisabled(true);
      setIsFormSubmit(false);
      if (userRBAC && userRBAC.isAccessible !== EntityAccess.ALLOWED) {
        updateReadStatus(item.id);
      }
      if (item.shareWithDriver === 1) setIsNoteShared(true);
      else setIsNoteShared(false);
      setNoteTempObj({
        id: item.id,
        userId: item.userId,
        note: item.note,
        shareWithDriver: item.shareWithDriver === 1 ? true : false,
        recordStatus: item.recordStatus,
        createdByUserId: item.createdByUserId,
        lastUpdatedByUserId: item.lastUpdatedByUserId,
        readStatus: item.readStatus,
        createdOn: item.createdOn,
        lastUpdatedOn: item.lastUpdatedOn,
        lastUpdatedByUserName: item.lastUpdatedByUserName,
        createdByUserName: item.createdByUserName,
      });
      if (editNoteClicked) {
        setShareWithDriver(item.shareWithDriver === 1 ? true : false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleRowClick(index, item) {
    setTextFieldDisabled(true);
    setSaveBtnDisabled(true);
    setEditNoteClicked(false);
    setDeleteNoteDisabled(false);
    setAddNoteClicked(false);
    setIsFormSubmit(false);
    setRowSelectedIndex(index);
    showNoteDetails(item);
  }

  const handleAddNoteClick = () => {
    setTextFieldDisabled(false);
    // inputRef.current.focus();
    setSaveBtnDisabled(false);
    setEditNoteClicked(true);
    setIsFormSubmit(false);
    setShareWithDriver(false);
    setNoteTempObj({
      id: "",
      userId: driverId,
      note: "",
      shareWithDriver: false,
      recordStatus: 1,
      createdByUserId: "",
      lastUpdatedByUserId: "",
      createdOn: "",
      readStatus: 0,
      lastUpdatedOn: "",
      lastUpdatedByUserName: "",
      createdByUserName: "",
    });
    setAddNoteClicked(true);
    setIsNoteShared(false);
    setRowSelectedIndex(-1);
    setDeleteNoteDisabled(true);
  };

  const handleShareWithDriverChange = (event) => {
    if (event.target.checked) setShareWithDriver(true);
    else setShareWithDriver(false);
    setNoteTempObj({
      ...noteTempObj,
      shareWithDriver: event.target.checked ? true : false,
    });
    var index = noteData.noteList.indexOf(noteTempObj.id);
    index = noteData.noteList.findIndex((item) => item.id === noteTempObj.id);
    if (index !== -1) {
      let object = {
        id: noteTempObj.id,
        userId: noteTempObj.userId,
        note: noteTempObj.note,
        shareWithDriver: event.target.checked ? 1 : 0,
        recordStatus: noteTempObj.recordStatus,
        createdByUserId: noteTempObj.createdByUserId,
        lastUpdatedByUserId: noteTempObj.lastUpdatedByUserId,
        createdOn: noteTempObj.createdOn,
        readStatus: noteTempObj.readStatus,
        lastUpdatedOn: noteTempObj.lastUpdatedOn,
        lastUpdatedByUserName: noteTempObj.lastUpdatedByUserName,
      };
      noteData.noteList[index] = object;
    }
    setEditNoteClicked(true);
    setSaveBtnDisabled(false);
  };

  function updateNoteData(obj) {
    try {
      if (
        noteData?.noteList &&
        noteData.noteList.length > 0 &&
        rowSelectedIndex >= 0
      ) {
        const oldNoteDtls = noteData.noteList[rowSelectedIndex];
        setSaveBtnDisabled(compareLicenseObjects(oldNoteDtls, obj));
        if (editNoteClicked) {
          setNoteTempObj({
            ...noteTempObj,
            note: obj.note,
          });
          var index = noteData.noteList.indexOf(noteTempObj.id);
          index = noteData.noteList.findIndex(
            (item) => item.id === noteTempObj.id
          );
          if (index !== -1) {
            let object = {
              id: noteTempObj.id,
              userId: noteTempObj.userId,
              note: obj.note,
              shareWithDriver: noteTempObj.shareWithDriver ? 1 : 0,
              recordStatus: noteTempObj.recordStatus,
              createdByUserId: noteTempObj.createdByUserId,
              lastUpdatedByUserId: noteTempObj.lastUpdatedByUserId,
              createdOn: noteTempObj.createdOn,
              readStatus: noteTempObj.readStatus,
              lastUpdatedOn: noteTempObj.lastUpdatedOn,
              lastUpdatedByUserName: noteTempObj.lastUpdatedByUserName,
            };
            noteData.noteList[index] = object;
            // noteData.noteList.push(object);
          }
        } else {
          setNoteTempObj({ ...noteTempObj, note: obj.note });
        }
      } else {
        setSaveBtnDisabled(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function compareLicenseObjects(o1, o2) {
    try {
      for (var p in o1) {
        if (o1.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      for (var p in o2) {
        if (o2.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
    return true;
  }

  const deleteNoteDialogFunc = (isOpen, confirmDelete) => {
    setDeleteDialogOpen(isOpen);
    if (confirmDelete) {
      const obj = { ...noteTempObj, recordStatus: RecordStatus.DELETE };
      setNoteTempObj({ ...noteTempObj, recordStatus: RecordStatus.DELETE });
      upsertDriverNoteDetails(obj);
    }
  };

  const handleDeleteClose = (confirmDelete) => {
    setDeleteDialogOpen(false);
    deleteNoteDialogFunc(false, confirmDelete);
  };

  return (
    <Drawer open={open} anchor={anchor} onClose={handleClose}>
      <div style={{ width: "766px" }}>
        <CustomBox className={classes.driverNoteDrawerWrapper}>
          {userRBAC &&
            userRBAC.isAccessible === EntityAccess.ALLOWED &&
            !params.impersonationid ? (
              <>
                {deleteDialogOpen ? (
                  <CustomBox className={classes.deleteDialog}>
                    <CustomBox style={{ marginLeft: "27px" }}>
                      <CustomTypography
                        component="h1"
                        variant="h5"
                        noWrap
                        className={classes.deleteDialogText}
                      >
                        {t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_NOTE")}
                      </CustomTypography>
                    </CustomBox>
                    <CustomBox className={classes.deleteButtonContainer}>
                      <CustomButton
                        // autoFocus
                        className={classes.deleteButton}
                        onClick={() => handleDeleteClose(true)}
                        variant="contained"
                        // color="secondary"
                        defaultrounded="true"
                      >
                        {t("DELETE_NOTE")}
                      </CustomButton>
                      <Tooltip title="Close Dialog" placement="bottom">
                        <IconButton
                          aria-label="delete-dialog"
                          className={classes.deleteCloseButton}
                          onClick={() => handleDeleteClose(false)}
                        >
                          <img
                            src={closeNoteIcon}
                            style={{ height: "15px", width: "15px" }}
                          />
                        </IconButton>
                      </Tooltip>
                    </CustomBox>
                  </CustomBox>
                ) : (
                    <CustomBox className={classes.titleWrapper}>
                      {isNoteAdded || noteData?.noteList?.length ? (
                        <CustomBox
                          className={classes.title}
                          onClick={() => handleAddNoteClick()}
                        >
                          <img
                            style={{
                              cursor: "pointer",
                              height: "18px",
                              width: "18px",
                            }}
                            src={addNoteIcon}
                          />
                          <CustomTypography
                            component="h1"
                            variant="h5"
                            className={classes.addNewNote}
                          >
                            {t("ADD_NEW_NOTE")}
                          </CustomTypography>
                        </CustomBox>
                      ) : null}
                      <CustomBox className={classes.shareWithDriverWrapper}>
                        <Checkbox
                          checked={noteTempObj?.shareWithDriver}
                          color={"primary"}
                          disabled={isNoteShared}
                          onChange={(e) => handleShareWithDriverChange(e)}
                          inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                          style={isNoteShared ? { padding: '4px' } : { padding: "4px", cursor: "pointer" }}
                        />
                        <CustomTypography
                          component="h1"
                          variant="h5"
                          className={classes.addNewNote}
                        >
                          {t("SHARE_WITH_DRIVER")}
                        </CustomTypography>
                      </CustomBox>
                      <CustomBox>
                        <Tooltip title="Delete" placement="bottom">
                          <IconButton
                            aria-label="delete"
                            disabled={
                              noteData.noteList.length === 0
                                ? true
                                : deleteNoteDisabled
                            }
                            className={classes.closeButton}
                            onClick={() => deleteNoteDialogFunc(true, false)}
                          >
                            <img
                              src={deleteNoteIcon}
                              style={{ height: "20px", width: "15px" }}
                            />
                          </IconButton>
                        </Tooltip>
                        {!editNoteClicked ? (
                          <Tooltip title="Edit" placement="bottom">
                            <IconButton
                              aria-label="edit"
                              className={classes.closeButton}
                              onClick={() => handleEditClick()}
                            >
                              <img
                                src={editNoteIcon}
                                style={{ height: "20px", width: "15px" }}
                              />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        {editNoteClicked ? (
                          <Tooltip title="Save" placement="bottom">
                            <IconButton
                              disabled={saveBtnDisabled}
                              aria-label="save"
                              className={classes.closeButton}
                              onClick={() => handleSaveClick()}
                            >
                              <img
                                src={saveNoteIcon}
                                style={{ height: "20px", width: "15px" }}
                              />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        <Tooltip title="Close" placement="bottom">
                          <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={() => handleClose(false)}
                          >
                            <img
                              src={closeNoteIcon}
                              style={{ height: "20px", width: "15px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </CustomBox>
                    </CustomBox>
                  )}
              </>
            ) : (
              <CustomBox className={classes.titleWrapperForDriver}>
                <CustomBox>
                  <Tooltip title="Close" placement="bottom">
                    <IconButton
                      aria-label="close"
                      className={classes.closeButton}
                      onClick={() => handleClose(false)}
                    >
                      <img src={closeNoteIcon} />
                    </IconButton>
                  </Tooltip>
                </CustomBox>
              </CustomBox>
            )}
          <CustomBox className={classes.mainContent}>
            <CustomBox className={classes.leftPanel}>
              <CustomBox style={{ height: '100%', overflowY: 'auto' }}>
                {addNoteClicked && noteData.noteList.length ? (
                  <>
                    <CustomBox className={classes.noteItemRowSelected}>
                      <CustomBox className={classes.noteItem}>
                        <CustomBox className={classes.noteDesc}>
                          <CustomTypography
                            component="h1"
                            variant="h5"
                            noWrap
                            className={classes.noteText}
                          >
                            {noteTempObj.note}
                          </CustomTypography>
                          <CustomTypography
                            component="h1"
                            variant="h5"
                            className={classes.noteDate}
                          >
                            {/* {`${noteTempObj.lastUpdatedByUserName} | ${moment(
                              noteTempObj.lastUpdatedOn
                            ).format("DD MMM YYYY | hh:mm A")}`} */}
                            {`${loggedInUserData.firstName} ${loggedInUserData.lastName
                              }  |  ${moment(new Date()).format(
                                "DD MMM YYYY  |  hh:mm A"
                              )}`}
                          </CustomTypography>
                        </CustomBox>
                        <CustomBox className={classes.share}>
                          {shareWithDriver === true ? (
                            <img src={shareEnableIcon} />
                          ) : (
                              <img src={shareDisableIcon} />
                            )}
                        </CustomBox>
                      </CustomBox>
                      <Divider />
                    </CustomBox>
                  </>
                ) : null}
                {isApi && (
                  <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                    style={{ padding: "2em" }}
                  >
                    <CustomCircularProgress />
                  </CustomPaper>
                )}
                {!isApi && noteData && !noteData.noteList.length && (
                  <CustomPaper className={classes.loadingContainer} elevation={0}>
                    <CustomTypography
                      paragraph={true}
                      className={classes.title}
                      style={{ padding: "2em" }}
                    >
                      {t("NO_NOTES")}
                    </CustomTypography>
                  </CustomPaper>
                )}
                {!isApi && noteData && noteData.noteList.length
                  ? noteData.noteList.map((item, index) => {
                    {
                      return userRBAC &&
                        userRBAC.isAccessible === EntityAccess.ALLOWED ? (
                          params.impersonationid ? (
                            item.shareWithDriver !== 0 && (
                              <CustomBox
                                key={item.id}
                                className={
                                  rowSelectedIndex === index
                                    ? classes.noteItemRowSelected
                                    : classes.noteItemRow
                                }
                                // className={classes.noteItemRowSelected}
                                onClick={() => handleRowClick(index, item)}
                              >
                                <CustomBox className={classes.noteItem}>
                                  <CustomBox className={classes.noteDesc}>
                                    {((userRBAC &&
                                      userRBAC.isAccessible !==
                                      EntityAccess.ALLOWED) ||
                                      params.impersonationid) &&
                                      item.readStatus === 0 ? (
                                        <div className={classes.readTag} />
                                      ) : null}
                                    <CustomTypography
                                      component="h1"
                                      variant="h5"
                                      noWrap
                                      className={classes.noteText}
                                    >
                                      {item.note}
                                    </CustomTypography>
                                    <CustomTypography
                                      component="h1"
                                      variant="h5"
                                      className={classes.noteDate}
                                    >
                                      {`${item.lastUpdatedByUserName
                                        }  |  ${moment(item.lastUpdatedOn).format(
                                          "DD MMM YYYY  |  hh:mm A"
                                        )}`}
                                    </CustomTypography>
                                  </CustomBox>
                                  <CustomBox className={classes.share}>
                                    {item.shareWithDriver === 1 ? (
                                      <img src={shareEnableIcon} />
                                    ) : (
                                        <img src={shareDisableIcon} />
                                      )}
                                  </CustomBox>
                                </CustomBox>
                                <Divider />
                              </CustomBox>
                            )
                          ) : (
                              <CustomBox
                                key={item.id}
                                className={
                                  rowSelectedIndex === index
                                    ? classes.noteItemRowSelected
                                    : classes.noteItemRow
                                }
                                // className={classes.noteItemRowSelected}
                                onClick={() => handleRowClick(index, item)}
                              >
                                <CustomBox className={classes.noteItem}>
                                  <CustomBox className={classes.noteDesc}>
                                    {((userRBAC &&
                                      userRBAC.isAccessible !==
                                      EntityAccess.ALLOWED) ||
                                      params.impersonationid) &&
                                      item.readStatus === 0 ? (
                                        <div className={classes.readTag} />
                                      ) : null}
                                    <CustomTypography
                                      component="h1"
                                      variant="h5"
                                      noWrap
                                      className={classes.noteText}
                                    >
                                      {item.note}
                                    </CustomTypography>
                                    <CustomTypography
                                      component="h1"
                                      variant="h5"
                                      className={classes.noteDate}
                                    >
                                      {`${item.lastUpdatedByUserName}  |  ${moment(
                                        item.lastUpdatedOn
                                      ).format("DD MMM YYYY  |  hh:mm A")}`}
                                    </CustomTypography>
                                  </CustomBox>
                                  <CustomBox className={classes.share}>
                                    {item.shareWithDriver === 1 ? (
                                      <img src={shareEnableIcon} />
                                    ) : (
                                        <img src={shareDisableIcon} />
                                      )}
                                  </CustomBox>
                                </CustomBox>
                                <Divider />
                              </CustomBox>
                            )
                        ) : (
                          <CustomBox
                            key={item.id}
                            className={
                              rowSelectedIndex === index
                                ? classes.noteItemRowSelected
                                : classes.noteItemRow
                            }
                            // className={classes.noteItemRowSelected}
                            onClick={() => handleRowClick(index, item)}
                          >
                            <CustomBox className={classes.noteItem}>
                              <CustomBox className={classes.noteDesc}>
                                {((userRBAC &&
                                  userRBAC.isAccessible !==
                                  EntityAccess.ALLOWED) ||
                                  params.impersonationid) &&
                                  item.readStatus === 0 ? (
                                    <div className={classes.readTag} />
                                  ) : null}
                                <CustomTypography
                                  component="h1"
                                  variant="h5"
                                  noWrap
                                  className={classes.noteText}
                                >
                                  {item.note}
                                </CustomTypography>
                                <CustomTypography
                                  component="h1"
                                  variant="h5"
                                  className={classes.noteDate}
                                >
                                  {`${item.lastUpdatedByUserName}  |  ${moment(
                                    item.lastUpdatedOn
                                  ).format("DD MMM YYYY  |  hh:mm A")}`}
                                </CustomTypography>
                              </CustomBox>
                              <CustomBox className={classes.share}>
                                {item.shareWithDriver === 1 ? (
                                  <img src={shareEnableIcon} />
                                ) : (
                                    <img src={shareDisableIcon} />
                                  )}
                              </CustomBox>
                            </CustomBox>
                            <Divider />
                          </CustomBox>
                        );
                    }
                  })
                  : null}
              </CustomBox>
            </CustomBox>
            <CustomBox className={classes.rightPanel}>
              <CustomBox style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <CustomBox style={{ alignSelf: "center" }}>
                  <Alert
                    code={noteAlertStatusValue}
                    message={noteAlertMessage}
                    isOpen={isNoteAlertOpen}
                    setIsOpenAlert={setIsNoteAlertOpen}
                    alertType={noteAlertType}
                    isClose={(isClose) => setIsNoteAlertOpen(!isClose)}
                  />
                </CustomBox>
                <CustomBox style={{ alignSelf: "center" }}>
                  <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.noteDate1}
                  >
                    {noteTempObj.id
                      ? `${noteTempObj.lastUpdatedByUserName} | ${moment(
                        noteTempObj.lastUpdatedOn
                      ).format("DD MMM YYYY | hh:mm A")}`
                      : null}
                  </CustomTypography>
                </CustomBox>
                <CustomBox style={{ alignSelf: "center" }}>
                  <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.noteContent}
                  >
                    <FormHelperText
                      id="component-error-text"
                      style={{ color: "#f44336" }}
                    >
                      {isFormSubmit
                        ? noteFormValidation["note"].validationMessage
                        : null}
                    </FormHelperText>
                    <CustomTextField
                      required
                      autoFocus
                      disabled={ userRBAC && userRBAC.isAccessible === EntityAccess.ALLOWED
                          ? params.impersonationid ? true : editNoteClicked ? false : true : true
                      }
                      className={classes.userInput}
                      fullWidth
                      multiline
                      rows={35}
                      type="text"
                      placeholder={
                        userRBAC && userRBAC.isAccessible === EntityAccess.ALLOWED
                        ? params.impersonationid ? `${t("SELECTED_NOTE_WILL_BE_SHOWN_HERE")}` : `${t("WRITE_A_NOTE_FOR_DRIVER")}`
                        : `${t("SELECTED_NOTE_WILL_BE_SHOWN_HERE")}`
                      }
                      // label={`${t("WRITE_A_NOTE_FOR_DRIVER")}`}
                      value={noteTempObj.note}
                      onChange={(e) => {
                        const updatedObj = {
                          ...noteTempObj,
                          note: e.target.value,
                        };
                        setNoteTempObj({
                          ...noteTempObj,
                          note: e.target.value,
                        });
                        if (e.target.value.length > 0) setSaveBtnDisabled(false);
                        else setSaveBtnDisabled(true);
                        updateNoteData(updatedObj);
                      }}
                      InputLabelProps={{ shrink: true }}
                      inputRef={(input) => {
                        if (input && !textFieldDisabled) {
                          input.focus();
                        }
                      }}
                      InputProps={{
                        disableUnderline: true,
                        required: true,
                        sx: { height: 480 },
                      }}
                      error={
                        noteFormValidation["note"].isValid || !isFormSubmit
                          ? false
                          : true
                      }
                    />
                  </CustomTypography>
                </CustomBox>
              </CustomBox>
            </CustomBox>
          </CustomBox>
        </CustomBox>
      </div>
    </Drawer>
  );
}

const Alert = ({
  code,
  message,
  isOpen,
  alertType,
  isClose,
  setIsOpenAlert,
}) => {
  const useStyles = makeStyles((theme) => ({
    alertBox: {
      padding: theme.spacing(3, 0, 1, 0),
    },
    alertTypeGreen: {
      fontSize: 10,
      color: "rgba(112, 222, 127)",
      fontWeight: 500,
    },
    alertTypeRed: {
      fontSize: 10,
      color: "rgba(251, 35, 64)",
      fontWeight: 500,
    },
  }));
  const classes = useStyles();

  React.useEffect(() => {
    const timeId = setTimeout(() => {
      setIsOpenAlert(false);
    }, 4000);
    return () => {
      clearTimeout(timeId);
    };
  }, [isOpen]);

  return (
    <>
      {isOpen ? (
        <CustomBox className={classes.alertBox}>
          <CustomTypography
            component="h1"
            variant="h5"
            className={
              alertType === "success"
                ? classes.alertTypeGreen
                : classes.alertTypeRed
            }
          >
            {message}
          </CustomTypography>
        </CustomBox>
      ) : null}
    </>
  );
};
